module.exports = __webpack_public_path__ + "img/head_bg1.e16e9c69.png";